import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Home, UserCircle2, ClipboardPenLine, Inbox, Menu } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

const SIDE_TABS = [
  { id: 'home', label: 'الرئيسية', icon: Home, path: '/coach' },
  { id: 'profile', label: 'ملفي', icon: UserCircle2, path: '/coach/profile' },
];
const SIDE_TABS_2 = [
  { id: 'requests', label: 'الطلبات', icon: Inbox, path: '/coach/requests', badge: true },
  { id: 'more', label: 'المزيد', icon: Menu, isAction: true },
];

const isActive = (pathname, path) => pathname === path || (path !== '/coach' && pathname.startsWith(path + '/'));

const TabButton = ({ tab, active, onClick, badgeCount }) => {
  const Icon = tab.icon;
  return (
    <button
      onClick={onClick}
      data-testid={`mobile-nav-${tab.id}`}
      className="flex flex-1 flex-col items-center justify-center gap-0.5 py-2 transition-transform active:scale-90"
    >
      <span className="relative">
        <Icon className={`h-5 w-5 ${active ? 'text-teal-600' : 'text-slate-400'}`} strokeWidth={active ? 2.3 : 1.8} />
        {tab.badge && badgeCount > 0 && (
          <span className="absolute -left-2 -top-1.5 flex h-[15px] min-w-[15px] items-center justify-center rounded-full bg-red-500 px-1 text-[8px] font-bold text-white ring-2 ring-white">
            {badgeCount > 9 ? '9+' : badgeCount}
          </span>
        )}
      </span>
      <span className={`text-[10px] font-semibold ${active ? 'text-teal-600' : 'text-slate-400'}`}>{tab.label}</span>
    </button>
  );
};

export default function CoachMobileBottomNav({ onMore }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [badgeCount, setBadgeCount] = useState(0);

  useEffect(() => {
    axios.get(`${API}/coaches/me/dashboard`, auth())
      .then((res) => setBadgeCount((res.data?.pending_requests_count || 0) + (res.data?.pending_offers_count || 0)))
      .catch(() => {});
  }, [location.pathname]);

  const studioActive = isActive(location.pathname, '/coach/studio');

  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-50 border-t border-slate-200 bg-white/95 backdrop-blur-lg lg:hidden"
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
      data-testid="coach-mobile-bottom-nav"
    >
      <div className="mx-auto flex max-w-lg items-center px-1">
        {SIDE_TABS.map((tab) => (
          <TabButton key={tab.id} tab={tab} active={isActive(location.pathname, tab.path)} onClick={() => navigate(tab.path)} />
        ))}

        <div className="flex flex-1 flex-col items-center">
          <button
            onClick={() => navigate('/coach/studio')}
            data-testid="mobile-nav-studio"
            className="-mt-6 flex h-13 w-13 items-center justify-center rounded-full bg-gradient-to-br from-teal-500 to-emerald-600 shadow-lg shadow-teal-500/35 ring-[3px] ring-white transition-transform active:scale-90"
            style={{ height: '52px', width: '52px' }}
          >
            <ClipboardPenLine className="h-5.5 w-5.5 text-white" style={{ height: '22px', width: '22px' }} strokeWidth={2} />
          </button>
          <span className={`-mt-0.5 text-[10px] font-bold ${studioActive ? 'text-teal-600' : 'text-slate-500'}`}>العمل الفني</span>
        </div>

        {SIDE_TABS_2.map((tab) => (
          <TabButton
            key={tab.id}
            tab={tab}
            active={!tab.isAction && isActive(location.pathname, tab.path)}
            badgeCount={badgeCount}
            onClick={() => (tab.isAction ? onMore() : navigate(tab.path))}
          />
        ))}
      </div>
    </nav>
  );
}
